import { useContext } from 'react';
import { useQuery } from 'react-query';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { ace_index_api } from '@axo/shared/data-access/api';
import { ace_index } from '@axo/shared/data-access/types';
import { aceIndexKeys } from '../../cache-keys/aceIndexKeys';

export function useACEIndexQuery(input: ace_index.FindInput) {
  const api = useAPI();
  const ctx = useContext(DataAccessContext);
  const token = ctx?.state?.user?.token ?? '';

  return useQuery({
    queryKey: aceIndexKeys.query(input),
    queryFn: ({ queryKey: [, , query] }) => ace_index_api.find(api)(query),
    enabled: token.length > 0 && !queryIsEmpty(input),
    refetchOnWindowFocus: false,
  });
}

function queryIsEmpty(query: ace_index.FindInput): boolean {
  const excluded: (keyof typeof query)[] = [
    'PaginationParameters',
    'Sort',
    'SortV2',
    'LoanApplicationMarketCountry',
    'LockLockedByID',
  ];

  for (const key in query) {
    if (excluded.includes(key as keyof typeof query)) {
      continue;
    }

    if (query[key as keyof typeof query] !== undefined) {
      return false;
    }
  }

  return true;
}
